import { useParams } from 'react-router-dom';
import type { ReactNode } from 'react';

import placementApi from '@features/placements/services/placement-api';
import NotFound from '@src/shared/pages/not-found';

export function PlacementIdValidator({ children }: { children: ReactNode }) {
  const { id } = useParams() as { id: string };

  const { error } = placementApi.useFetchOne(
    { id },
    { enabled: !!id, retry: false }
  );

  if (error) return <NotFound />;

  return children;
}
